import React, { useEffect, useState } from "react";
import { ArrowRight, Clock, Activity, Shield, FileText } from "lucide-react";

const WelcomeScreen = ({ onStart }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="screen-container justify-center">
      <div
        className="content-wrapper"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      >
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/logos._lbs_conecti.png"
            alt="Groupe LBS Conecti"
            style={{
              display: "block",
              margin: "0 auto",
              width: "100%",
              height: "auto",
            }}
          />
          <div
            className="mx-auto mt-3"
            style={{ width: 40, height: 3, backgroundColor: "#B5163A", borderRadius: 2 }}
          />
        </div>

        {/* Main card */}
        <div className="card p-8 text-center mb-6">
          <div className="flex justify-center mb-5">
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                backgroundColor: "#12354D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Activity size={32} color="#B5163A" />
            </div>
          </div>

          <h2
            className="text-2xl font-bold text-center mb-3"
            style={{ fontFamily: "Montserrat, sans-serif", color: "#12354D" }}
          >
            Diagnostic de<br />fluidité numérique
          </h2>

          <p
            className="text-sm leading-relaxed mb-6"
            style={{ color: "#4A4A4A", fontFamily: "Inter, sans-serif" }}
          >
            Évaluez la maturité numérique de votre entreprise en 5 questions.
            Découvrez votre score, votre gain de temps potentiel, et recevez
            un rapport PDF personnalisé.
          </p>

          <div
            className="flex items-center justify-center gap-2 mb-7"
            style={{ color: "#9CA3AF" }}
          >
            <Clock size={14} />
            <span style={{ fontSize: 13, fontFamily: "Inter, sans-serif" }}>
              3 minutes · 5 questions · Rapport PDF offert
            </span>
          </div>

          <button
            data-testid="start-button"
            className="btn-primary"
            onClick={onStart}
          >
            Démarrer le test
            <ArrowRight size={20} />
          </button>
        </div>

        {/* Features */}
        <div className="grid grid-cols-3 gap-3">
          {[
            { icon: <Activity size={18} />, label: "Score /100" },
            { icon: <Clock size={18} />, label: "Gain / jour" },
            { icon: <FileText size={18} />, label: "Rapport PDF" },
          ].map((item, i) => (
            <div
              key={i}
              className="text-center"
              style={{
                background: "rgba(255,255,255,0.07)",
                borderRadius: 12,
                padding: "14px 8px",
              }}
            >
              <div
                className="flex justify-center mb-1.5"
                style={{ color: "rgba(255,255,255,0.5)" }}
              >
                {item.icon}
              </div>
              <p
                style={{
                  color: "rgba(255,255,255,0.55)",
                  fontSize: 11,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
